import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { externalLayersKeys } from './queryKeys';
import type { CreateManyExternalLayersBody } from 'hooks/externalLayer/types';
import { layerNodesKeys } from 'hooks/layerNode/queryKeys';

export function useCreateManyExternalLayersMutation() {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, CreateManyExternalLayersBody>({
    mutationFn: async (input: CreateManyExternalLayersBody) => {
      const resp = await axios.post(
        `${config.apiGateway.external_layers}/create_many`,
        {
          groupGuid: input.groupGuid,
          targetFolderId: input.targetFolderId ?? null,
          layers: input.layers,
        }
      );

      return resp.data;
    },
    onSuccess: () => {
      toast.success('External layers imported');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: externalLayersKeys.all() });
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
  });
}
